export default __webpack_public_path__ + "static/media/Roboto-Regular.6bede58e.ttf";